
var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Classes.AjaxXMLRequestJSON = new Class({
    Extends: OCS.Classes.AjaxXMLRequest,
    class_name: "AjaxXMLRequestJSON",
    options: {
        /*onError: function(text, error){},*/
        secure: true
    },
    initialize: function (options) {
        this.parent(options);
        Object.append(this.headers, {
            'Accept': 'application/json',
            //'X-Request': 'JSON'
        });
    },
    success: function (response) {
        var json;
        if(!this.response.json) {
            try {
                json = this.response.json = JSON.decode(response.text, this.options.secure);
            } catch (error) {
                this.fireEvent('error', {text: response.text, error: error});
                return;
            }
        } else {
            json = this.response.json;
        }
        
        if (json === null) {
            this.failure();
        } else {
            this.onSuccess(this.response);
            this.resolve(this.response);
        }
    }

});
